import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  Output,
  EventEmitter
} from "@angular/core";
import { Answer } from "../models/answer";
import { SaveSurveyCommand } from "../models/savesurveycommand";
import { SurveyQuestionVm } from "../models/surveyquestionVm";
import { SurveyService } from "../services/survey.service";
import { LocalstorageService } from "../services/localstorage.service";
import { AuthDetails } from "../models/auth-details.model";
import { PeopleDto } from "../models/people.model";

@Component({
  selector: 'app-mssparkyform',
  templateUrl: './mssparkyform.component.html',
  styleUrls: ['./mssparkyform.component.css']
})
export class MssparkyformComponent implements OnInit, AfterViewInit {
  private _allQuestions: SurveyQuestionVm[] = [];
  private _pristineQuestions: SurveyQuestionVm[] = [];
  private _conditionalQuestions: SurveyQuestionVm[] = [];
  success: boolean = false;
  surveyEntryId: number;
  pdfUrl: string;
  public currentQuestion: any;
  visibleQuestions: SurveyQuestionVm[] = [];
  message: string = '';
  readerFileDetails: string = "";
  files: string[] = [];
  showPDF: boolean = true;
  surveyId: number;
  selectedSurveyInfo: any;
  surveyUrl: string;
  surveyCode: string;
  isSubmitting: boolean = false;
  selectedPersonJobDesc: PeopleDto | null = null;
  onPersonSelected(emp: PeopleDto) {
    this.selectedPersonJobDesc = emp;
  }
  @Output() submitEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() hideWelcome = new EventEmitter<void>();
  @Input() set questions(value: SurveyQuestionVm[]) {
    this._pristineQuestions = value;
    this._allQuestions = value;
    if (this._allQuestions) this._conditionalQuestions = this._allQuestions.filter(q => q.decisionFieldName != null);
  }
  get questions() {

    if (this._allQuestions == undefined) return [];
    if (this.currentQuestion == undefined) {
      this.visibleQuestions = this._allQuestions.filter(x => x.decisionFieldName == null);
      return this.visibleQuestions;
    }

    let conditionalQuestions: SurveyQuestionVm[] = this._allQuestions.filter((a) =>
      a.decisionFieldName == this.currentQuestion.questionFieldName &&
      a.decisionResponse.indexOf('|' + this.currentQuestion.answerText + '|') >= 0
    );

    //remove conditional questions for currrent question 
    let quetionsAlreadyAdded = this.visibleQuestions.filter((q) => q.decisionFieldName == this.currentQuestion.questionFieldName);
    quetionsAlreadyAdded.forEach(qa => {
      if (qa.decisionResponse != this.currentQuestion.answerText) {
        this.visibleQuestions.splice(this.visibleQuestions.indexOf(qa), 1);
      }
    })

    //Remove conditional questions which don't have a parent
    this.visibleQuestions.filter(s => s.decisionFieldName != null).forEach(c => {
      let foundParent = this.visibleQuestions.some(q => q.questionFieldName == c.decisionFieldName);
      if (!foundParent) {
        this.visibleQuestions.splice(this.visibleQuestions.indexOf(c), 1);
      }
    });

    //Insert conditional questions if any
    if (conditionalQuestions.length > 0) {
      const found = this.visibleQuestions.some((r) => conditionalQuestions.includes(r));
      if (!found) {
        this.visibleQuestions.splice(this.visibleQuestions.indexOf(this.currentQuestion) + 1, 0, ...conditionalQuestions);
      }
    }
    console.log('this.visibleQuestions', this.visibleQuestions);
    return this.visibleQuestions;
  }
  constructor(
    private surveyService: SurveyService,
    private localstorageService: LocalstorageService) { }
  getAuthDetails: AuthDetails;
  async ngOnInit() {
    this.getAuthDetails = this.localstorageService.getAuth();
  }

  onRadioChanged(currentQuestionEvent: any) {
    console.log(currentQuestionEvent);
    this.currentQuestion = currentQuestionEvent;
    const idx = this.visibleQuestions.findIndex(q => q.questionFieldName === currentQuestionEvent.questionFieldName);
    if (idx !== -1) {
      // Clear answers for all questions after the current one
      for (let i = idx + 1; i < this.visibleQuestions.length; i++) {
        this.visibleQuestions[i].answerText = '';
        if ('otherText' in this.visibleQuestions[i]) {
          // @ts-ignore - otherText may not exist on type
          this.visibleQuestions[i].otherText = '';
        }
      }
    }
  }

  ngAfterViewInit() { }

  loadExistingResponseById(headerId: number) {

  }

  changeFirstCharToLowerCase(fieldName: string): string {
    if (!fieldName) return fieldName;
    return fieldName.charAt(0).toLowerCase() + fieldName.slice(1);
  }

  isFormInvalid() {
    let invaliddate = this.visibleQuestions
      .filter((q) => q.required == true && q.dataTypeName == "date")
      .some((q) => q.answerText == null || q.answerText.toString() == "");
    let invalidText = this.visibleQuestions
      .filter((q) => q.required == true && q.dataTypeName == "text")
      .some((q) => q.answerText == null || q.answerText.toString() == "");
    let invalidTextArea = this.visibleQuestions
      .filter((q) => q.required == true && q.dataTypeName == "textarea")
      .some((q) => q.answerText == null || q.answerText.toString() == "");

    let radioInvalid = this.visibleQuestions
      .filter((q) => q.required == true && q.dataTypeName == "radio")
      .some((q) => q.answerText == null || q.answerText.toString() == "");

    let phoneInvalid = this.visibleQuestions.filter(q => q.validations == 'PhoneNumber')
      .some(p => {
        const value = p.answerText ? p.answerText.toString() : '';
        return (new RegExp("^[0-9]{10}$|^[0-9\\-]{12}$")).test(value) == false;
      });

    let emailInvaild = this.visibleQuestions.filter(q => q.validations == 'Email')
      .some(p => {
        const value = p.answerText ? p.answerText.toString() : '';
        return (new RegExp("^.+@.+\\..+$")).test(value) == false;
      });

    let invaliddateOtherText = this.visibleQuestions
      .filter((q) => q.required == true && q.dataTypeName == "radio" && q.answerText == "Other - [UserText]")
      .some((q) => q.otherText == null || q.otherText.toString() == "");

    let isAnswerTextNull = this.visibleQuestions
      .some(q => q.answerText === null || q.answerText === '');

    console.log("Invalid states:", { invalidText, invaliddate, phoneInvalid, emailInvaild, radioInvalid, invaliddateOtherText, invalidTextArea, isAnswerTextNull });
    return invalidText || invaliddate || phoneInvalid || emailInvaild || radioInvalid || invaliddateOtherText || invalidTextArea || isAnswerTextNull;
  }


  get isFormReadyToSubmit() {
    return !this.isFormInvalid();
  }
  get validationErrors() {
    let errorMessage = "";
    this.questions.forEach((q, index) => {
      if (q.answerText == "") {
        errorMessage += index + 1 + ", ";
      }
    });

    return errorMessage.length > 0 ? errorMessage + " Required" : errorMessage;
  }


  async submit() {

    this.hideWelcome.emit();
    let saveEntryData: SaveSurveyCommand = new SaveSurveyCommand();

    const qs = this.questions;
    if (!qs || qs.length === 0) return;

    saveEntryData.surveyAppId = qs[0].surveyAppId;
    this.surveyCode = qs[0].surveyCode;

    let answers: Answer[] = [];
    qs.forEach((q) => {
      let tempAnswer: Answer = new Answer();
      tempAnswer.questionFieldName = q.questionFieldName;
      tempAnswer.answerText = q.answerText == "Other - [UserText]" ? q.otherText : q.answerText;
      answers.push(tempAnswer);
    });

    saveEntryData.items = answers;
    saveEntryData.surveyCode = this.surveyCode;
    saveEntryData.authenticated = this.getAuthDetails?.isAuthenticated ?? false;
    saveEntryData.corpId = this.getAuthDetails?.employeeInfo?.corpId;
    saveEntryData.firstName = this.getAuthDetails?.employeeInfo?.firstName;
    saveEntryData.lastName = this.getAuthDetails?.employeeInfo?.lastName;
    saveEntryData.workEmail = this.getAuthDetails?.verificationData?.workEmail;
    saveEntryData.employeeId = this.getAuthDetails?.verificationData?.employeeId;

    console.log(saveEntryData);

    this.isSubmitting = true;

    this.message = 'Thank you for submitting a SPARK moment! An email has been sent to the team member and their manager.';

    this.surveyService.saveSurvey(saveEntryData).subscribe(
      (responseData) => {
        //success
        console.log('responseData', responseData);
        this.surveyEntryId = responseData;
        this.pdfUrl = '/s/api/survey/survey-pdf/' + this.surveyEntryId;
        this.isSubmitting = false;
        this.success = true;
      },
      (error) => {
        console.error(error);
        this.isSubmitting = false;
      }
    );
  }
}
